import React, { Component } from 'react';
import { GenericEditPanel, GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';

class CodigoPlanta extends Component {
    constructor(props) {
        super(props);

        this.actualizarNovedadEstado = this.actualizarNovedadEstado.bind(this);
        this.changeInput = this.changeInput.bind(this);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} entidadId
     */
    actualizarNovedadEstado(novedad, estadoId, entidadId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, entidadId)
    }
    /**
     * 
     * @param {any} event
     */
    changeInput(event) {
        this.props.changeInput(1, this.props.codigoNovedad, event.target.value)
    }
    /**
     * 
     */
    render() {
        let me = this;
        let errors;
        const { getFieldProps, getFieldError } = this.props.form;
        let errorContainer;
        let props = this.props;
        let seEstaEditando = props.dataCompleto.seEstaEditando;

        errorContainer = <label className="error">
            {(errors = getFieldError('codigo')) ? errors.join(',') : null}</label>

        let error = (getFieldError('codigo')) ? true : false

        //////////Novedad en Codigo de planta////////////
        let descripcion = props.data.Planta;
        let novedadCodigoPlanta = undefined;
        if (props.dataCompleto.novedadesCuentaDatos != undefined) {
            novedadCodigoPlanta = props.dataCompleto.novedadesCuentaDatos.find(x => x.NovedadCampoCodigo == this.props.codigoNovedad);
            if (novedadCodigoPlanta) {
                let esNovedadEditadaDescripcion = props.dataCompleto.esNovedadEditada.find(x => x.campoCodigo == this.props.codigoNovedad).editado;
                if (esNovedadEditadaDescripcion == false) {
                    descripcion = novedadCodigoPlanta.ValorNovedad;
                }
            }
        }
        ////////////////////////////////////////////////////

        let componente = (
            <div>
                <GenericInputValidate
                    getFieldProps={getFieldProps('codigo', {
                        onChange(e) {
                            me.changeInput(e);
                        },
                        rules: [{
                            required: false,
                            pattern: /^[a-zA-Z0-9\s]*$/,
                            message: 'Debe ingresar código válido.'
                        }]
                    })}
                    id="codigo"
                    name="codigo"
                    value={descripcion}
                    className="form-control default-input"
                    autoComplete="off"
                />
                {errorContainer}
            </div>
        )

        return (
            <GenericEditPanel
                componente={componente}
                cuenta={props.data}
                error={error}
                permisoUsuario={props.dataCompleto.funcionesDelUsuario}
                novedad={novedadCodigoPlanta}
                seEstaEditando={seEstaEditando}
                textPanel={descripcion || "Sin especificar"}
                title="Código de planta"
                value={descripcion}

                aceptChanges={(value) => this.props.guardarNovedad(value)}
                confirmarNovedad={() => this.actualizarNovedadEstado(novedadCodigoPlanta, 2, props.data.CuentaTarjetaId)}
                changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                denegarNovedad={() => this.actualizarNovedadEstado(novedadCodigoPlanta, 3, props.data.CuentaTarjetaId)}
                mostrarModificaciones={this.props.mostrarModal}
                revert={this.props.cancelar}
            />
        );
    }
}

export default CodigoPlanta;